import { toast } from 'sonner'

/** エージェント（todo-executor スキル）にそのまま貼り付けて実行できる指示文 */
export function buildTodoImplementCommand(id: number): string {
  return `TODO ${id} を実装して`
}

export async function copyTodoImplementCommand(id: number): Promise<void> {
  const command = buildTodoImplementCommand(id)
  try {
    await navigator.clipboard.writeText(command)
    toast.success(`「${command}」をコピーしました`)
  } catch {
    toast.error('コピーに失敗しました')
  }
}
